var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main user-layout-register"},[_vm._v(" 模式页面 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }